"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_create_event_controller_1 = __importDefault(require("./admin-create-event.controller"));
var admin_create_event_html_1 = __importDefault(require("./admin-create-event.html"));
function getVehicles(VehiclesModel) {
    return VehiclesModel.getVehicles({ all: true, status: "available" }).then(function (response) {
        return response.vehicles;
    });
}
getVehicles.$inject = ["VehiclesModel"];
function getCampuses(LocationsModel) {
    return LocationsModel.getLocations().then(function (response) {
        return response;
    });
}
getCampuses.$inject = ["LocationsModel"];
function getClassrooms(ClassroomsModel) {
    return ClassroomsModel.search({})
        .then(function (response) {
        return [{ id: 0, name: "None" }].concat(response.classrooms);
    })
        .catch(function (error) {
        return error;
    });
}
getClassrooms.$inject = ["ClassroomsModel"];
function getInstructors(UsersModel) {
    return UsersModel.getInstructors({ all: true, status: "Active" }).then(function (response) {
        return response.instructors;
    });
}
getInstructors.$inject = ["UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.events.create", {
        url: "/create",
        template: admin_create_event_html_1.default,
        controller: admin_create_event_controller_1.default,
        controllerAs: "vm",
        resolve: {
            campuses: getCampuses,
            vehicles: getVehicles,
            classrooms: getClassrooms,
            instructors: getInstructors,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.events.create", [])
    .config(config)
    .controller("AdminEventsCreateController", admin_create_event_controller_1.default);
